export const ACCESS_TOKEN_KEY = `USER_ACCESS_TOKEN_DATA_${process.env.VUE_APP_ENV}`;

export const RESUIT_GROUP = `${process.env.VUE_APP_ENV}.result_group`;
